module.exports = __webpack_public_path__ + "img/confused.1262d261.svg";